import { FC } from 'react';
import { isNotEmptyAny } from '@lhb/func';
import styles from './index.module.less';
import CircleTaskDetailHeader from '@/views/expandstore/pages/expansioncircletask/components/Detail/components/Header';
import TaskDetailTitle from './TaskDetailTitle';
import Title from './Title';

/**
 * 审批详情抽屉-顶部
 * @description
 * @demo
 */
const Component:FC<{
  aprDetail: any,
  taskDetail: any,
  planSpotDetail: any,
  taskTemplateCode: any,
  hintStr: any,
  titleHeightRef: any,
}> = ({ aprDetail, taskDetail, planSpotDetail, taskTemplateCode, hintStr, titleHeightRef }) => {

  /* state */

  /* hooks */

  /* methods */

  return (<div className={styles.header}>
    {
      taskDetail
        ? (taskTemplateCode !== 'standardA'
          ? <CircleTaskDetailHeader detail={taskDetail} hideOperate={true} isApproval />
          : <TaskDetailTitle titleHeightRef={titleHeightRef} detail={taskDetail} />)
        : <Title
          detail={aprDetail}
          titleHeightRef={titleHeightRef}
          hideNodes={isNotEmptyAny(planSpotDetail)}
          hintStr={hintStr}/>
    }
  </div>);
};

export default Component;
